import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchLocationsResponse>}
 */
export function requestLocations(params) {
  return fetch.get(`${BASE_URL}/api/app/location`, {
    params: { limit: 10000 },
  });
}
